import Vue from 'vue';
import kebabCase from 'lodash/kebabCase';

const requireComponent = require.context('./pages', true, /\.vue$/, 'lazy');

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    const name = kebabCase(fileName.replace(/\.\w+$/, ''));
    const prefix = /-[0-9]+$/.test(name) ? 'page-' : 'comp-';
    const componentName = prefix + name;
    Vue.component(componentName, () => componentConfig.then(m => m.default));
});
